<app-column-header [headerData]="headerData" ></app-column-header>
<!-- <div class="content-side"> -->
    <div class="row">
        <!-- <div class="col-2-of-2"> -->
            <!-- <div class="commonBlock">                 -->
                <div class="histories">
                    <ul class="headings">
                        <li>Action </li>
                        <li>Date & Time </li>
                        <li>User </li>
                        <li>IP Address</li>
                        <li>Machine Name</li>
                        <li class="sub">
                            <ul>
                                <li>Field Name</li>
                                <li>New Value</li>
                                <li>Old Value</li>
                            </ul>
                        </li>
                    </ul>                   
                   <ul class="dataOne" *ngFor="let data of auditData">
                        <li>
                            <span>{{data.gstibo_action}}</span>
                
                        </li>
                        <li>
                            <span>{{data.gstibo_created_on | date: "dd/MM/yyyy HH:mm " }}</span>
                
                        </li>
                        <li>
                            <span>{{data.gstibo_User}}</span>
                
                        </li>
                        <li>
                            <span>
                                ::1
                            </span>
                
                        </li>
                        <li>
                            <span>
                                machine
                            </span>
                
                        </li>
                
                        <li class="sub">
                
                            <ul *ngFor="let logData of data.log">
                                <li *ngIf="logData.length>0">{{logData.split("~~")[0]}}</li>
                                <li *ngIf="logData.split('~~')[1] !=null && (logData.split('~~')[1]).split('~') != null">{{(logData.split("~~")[1]).split("~")[0]}}</li>
                                <li *ngIf="logData != null && logData.split('~~')[1] !=null && (logData.split('~~')[1]).split('~') != null">{{(logData.split("~~")[1]).split("~")[1]}}</li>
                            </ul>
                
                        </li>
                    </ul>
                </div>
            <!-- </div> -->
        <!-- </div> -->
    </div>
<!-- </div> -->